module.exports = __webpack_public_path__ + "img/DOWNLOAD.13f9d2aa.svg";